import { FiGithub, FiLinkedin, FiMail } from "react-icons/fi";

const socials = [
  { label: "GitHub", href: "https://github.com/james-yu2005", Icon: FiGithub },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/james-yu2005/",
    Icon: FiLinkedin,
  },
  { label: "Email", href: "mailto:j85yu@uwaterloo.ca", Icon: FiMail },
];

export default function Hero() {
  return (
    <section className="min-h-[calc(100vh-4rem)] flex items-center">
      <div className="container-narrow w-full">
        <p className="text-muted mb-3">Hi, my name is</p>
        <h1 className="text-5xl md:text-6xl font-semibold tracking-tight mb-5">
          James Yu
        </h1>
        <p className="text-lg mb-2">Machine Learning Engineer</p>
        <p className="text-muted mb-10">
          BASc Biomedical Engineering at the University of Waterloo.
        </p>

        <div className="flex items-center gap-5">
          {socials.map(({ label, href, Icon }) => (
            <a
              key={label}
              href={href}
              {...(href.startsWith("http") && {
                target: "_blank",
                rel: "noopener noreferrer",
              })}
              className="text-muted hover:text-fg transition-colors"
              aria-label={label}
            >
              <Icon size={20} />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
